import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { DrawerFilters } from './DrawerFilters'
import {
	FilterButtonStyled,
	StyledCloseIcon,
	StyledDrawer,
	StyledFilterIcon,
	StyledTextButton,
} from './styles'
import type { IAppliedFilters } from './types'

interface Props {
	appliedFilters: IAppliedFilters
	handleCloseFiltersSidebar: () => void
	handleOpenFiltersSidebar: () => void
	handleResetFilters?: () => void
	isAlreadyFilteringBySupplier?: boolean
	isCustomer: boolean
	onApplyFilters: (appliedFilters: IAppliedFilters) => void
	openFiltersSidebar: boolean
}

export const countFilters = (appliedFilters: IAppliedFilters) =>
	Object.values(appliedFilters).filter(f => f !== undefined).length

const FilterButton: React.FC<Props> = ({
	appliedFilters,
	handleCloseFiltersSidebar,
	handleOpenFiltersSidebar,
	handleResetFilters,
	isAlreadyFilteringBySupplier,
	isCustomer,
	onApplyFilters,
	openFiltersSidebar,
}) => {
	const { t } = useTranslation()
	const filterCount = countFilters(appliedFilters)

	return (
		<>
			<StyledDrawer
				anchor="right"
				open={openFiltersSidebar}
				onClose={handleOpenFiltersSidebar}
			>
				<DrawerFilters
					appliedFilters={appliedFilters}
					onApplyFilters={onApplyFilters}
					onClose={handleCloseFiltersSidebar}
					isCustomer={isCustomer}
					isAlreadyFilteringBySupplier={isAlreadyFilteringBySupplier}
				/>
			</StyledDrawer>
			<FilterButtonStyled>
				{filterCount !== 0 && !!handleResetFilters && (
					<StyledTextButton variant="text" onClick={handleResetFilters}>
						<StyledCloseIcon />
						{t('button.resetFilters')}
					</StyledTextButton>
				)}
				<Button
					variant="outlined"
					color="primary"
					onClick={handleOpenFiltersSidebar}
				>
					{t('button.filter')} {filterCount > 0 && `(${filterCount})`}
					<StyledFilterIcon color="primary" />
				</Button>
			</FilterButtonStyled>
		</>
	)
}
export { FilterButton }
